import { graphql, useStaticQuery } from "gatsby"
import { TReusableCard } from "../types"

const allReusableCards = (): TReusableCard[] => {
  const query = useStaticQuery(
    graphql`
      query {
        allReusableCard {
          nodes {
            title
            cardData: cardType {
              ...VideoCardContent
              ...StandardCardContent
            }
          }
        }
      }
    `
  )
  return query.allReusableCard.nodes
}

export default allReusableCards
